import { getData as apiGetData } from 'api/Api'
import {
  init,
  setLoadStatus,
  setName as setBoardName,
  setLists,
  setIsTemplate,
  setIsPublic,
  setIsClosed,
} from '../redux/view'
import {
  set as setSettings
} from '../redux/settings'
import {
  addArray as addListArray
} from '../redux/lists'
import {
  addArray as addLabelArray
} from '../redux/labels'
import {
  addArray as addCardStatusArray
} from '../redux/cardStatuses'
import {
  addArray as addViewArray,
} from '../redux/views'
import viewError from 'store/sagas/viewError'
import { push } from 'index'
import fetchPermissionLevel from './fetchPermissionLevel'

type Payload = {
  boardId: number
}

export default (payload: Payload) => async (dispatch, getState) => {
  const { boardId } = payload

  dispatch([
    init({
      boardId,
    }),
    setLoadStatus({
      boardId,
      isLoading: true,
      isLoaded: false
    })
  ])

  try {
    const [
      { Name, Background, Settings, Lists, Labels, IsTemplate, IsPublic, IsClosed, Views, Statuses },
    ] = await Promise.all([
      apiGetData('Board', { id: boardId }),
      dispatch(fetchPermissionLevel({
        boardId
      })),
    ])

    const batchedActions: any[] = []

    // Name
    batchedActions.push(setBoardName({
      boardId,
      name: Name
    }))

    // Settings
    batchedActions.push(setSettings({
      boardId,
      settings: {
        allowCardRemove: Settings.AllowCardRemove,
        chat: Settings.Chat,
        joinMode: Settings.JoinMode,
        lang: Settings.Lang,
        timeline: Settings.Timeline,
        enableAnalytics: Settings.EnableAnalytics,
        background: Background,
        cardTemplateId: Settings.CardTemplateId
      }
    }))

    // Lists
    const listIds: number[] = []
    const lists: any[] = []

    Lists.forEach(List => {
      const list = {
        id: List.Id,
        name: List.Name,
        description: JSON.parse(List.Description),
        isObserved: List.IsObserved,
        position: List.Position,
        settings: {
          color: List.Settings.Color,
          wipLimit: List.Settings.WIPLimit,
        }
      }

      listIds.push(list.id)
      lists.push(list)
    })

    batchedActions.push(addListArray(lists))
    batchedActions.push(setLists({ boardId, lists: listIds }))

    // Labels
    batchedActions.push(addLabelArray({
      boardId,
      array: Labels.map(Label => ({
        id: Label.Id,
        name: Label.Name,
        color: Label.Color,
        position: Label.Position
      }))
    }))

    // IsTemplate
    batchedActions.push(setIsTemplate({ boardId, isTemplate: IsTemplate }))

    // IsPublic
    batchedActions.push(setIsPublic({ boardId, isPublic: IsPublic }))

    // IsPublic
    batchedActions.push(setIsClosed({ boardId, isClosed: IsClosed }))

    // Card Statuses
    batchedActions.push(addCardStatusArray({
      boardId,
      array: Statuses.map(Status => ({
        id: Status.Id,
        name: Status.Name,
        description: Status.Description,
        role: Status.Role,
        isDefault: Status.IsDefault,
        color: Status.Color,
        position: Status.Position
      }))
    }))

    // Views
    batchedActions.push(addViewArray({
      boardId,
      array: Views.map(View => ({
        id: View.Id,
        type: View.Type,
        name: View.Name,
        isPublic: View.IsPublic,
        settings: View.Settings,
        position: View.Position,
      }))
    }))

    batchedActions.push(setLoadStatus({
      boardId,
      isLoading: false,
      isLoaded: true
    }))

    dispatch(batchedActions)
  } catch (error) {
    if (error.code === 401) {
      const state = getState()
      dispatch(viewError({
        text: state.kanbo.locale.messages['BOARD_NOT_FOUND']
      }))
    } else if (error.code === 601) {
      const state = getState()
      dispatch(viewError({
        text: state.kanbo.locale.messages['BOARD_ACCESS_DENIED']
      }))
    } else {
      dispatch(viewError({
        error,
        refresh: true
      }))
    }

    dispatch(push('/'))

    dispatch(setLoadStatus({
      boardId,
      isLoading: false,
      isLoaded: false
    }))
  }
}
